/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_Messages_In_Threads_HintInputs */



/**
* | output |
* | --- |
* | "Allow members to send messages in threads and in posts on forum channels." |
*
* @param {Leveling_Perm_Send_Messages_In_Threads_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_messages_in_threads_hint = /** @type {((inputs?: Leveling_Perm_Send_Messages_In_Threads_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_Messages_In_Threads_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отправлять сообщения в ветках и в публикациях каналов-форумов.")
	return /** @type {LocalizedString} */ ("Allow members to send messages in threads and in posts on forum channels.")
});